// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IPostCollabDocItem,
}                               from '../interfaces';

const updatePostCollaborativePreviewCutoff = async ({
    test,
    docId,
    previewCutoffParagraphId,
    previewCutoffCheckpointId,
}: {
    test: boolean,
    docId: string,
    previewCutoffParagraphId?: string | null,
    previewCutoffCheckpointId?: string | null,
}): Promise<IPostCollabDocItem> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        Record<string, boolean | string | null | undefined>,
        IPostCollabDocItem
    >(
        functions,
        'updatePostCollaborativePreviewCutoff',
    );
    const result = await callable({
        test,
        docId,
        previewCutoffParagraphId,
        previewCutoffCheckpointId,
    });
    return result.data as IPostCollabDocItem;
};

export default updatePostCollaborativePreviewCutoff;
